import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./Farm.css";
import loadingImage from "../../../assets/images/loading.gif";
import Title from "../../../components/title/Title";
import { Modal } from "antd";
import useStateCallback from "../../../util/hooks/UseStateCallback";
import FarmEditor from "./FarmEditor";

import editIcon from "../../../assets/images/001-edit.png";

const Farm = () => {
  const params = useParams();
  const { id } = params;
  const [farm, setFarm] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isAddUserModalVisible, setIsAddUserModalVisible] = useState(false);
  const [isTestModalVisible, setIsTestModalVisible] = useState(false);
  const [testResponse, setTestResponse] = useState(null);
  const [errors, setErrors] = useState(null);
  const [user, setUser] = useState({
    name: "",
    username: "",
    password: "",
    userId: "",
    roles: ["user"],
  });
  const [displayFarmEditor, setDisplayFarmEditor] = useState(false);
  const [editUserId, setEditUserId] = useState(null);

  useEffect(() => {
    getFarm();
  }, [id]);

  const getFarm = async () => {
    setFarm(null);
    setError(null);
    setIsLoading(true);
    try {
      const response = await axios.get(`/api/farms/${id}`, {
        headers: { Authorization: localStorage.getItem("token") },
      });
      setFarm({ ...response.data.farm, users: response.data.users });
    } catch (error) {
      console.log(error.response.data);
      setError(error.response.data);
    } finally {
      setIsLoading(false);
    }
  };

  const onAddBtnClicked = () => {
    // open add user modal:
    clearForm();
    setEditUserId(null);
    setIsAddUserModalVisible(true);
  };

  const testConnection = async () => {
    try {
      const response = await axios.get(`/api/farms/${id}/test`, {
        headers: { Authorization: localStorage.getItem("token") },
      });
      setTestResponse(
        `Server: ${response.data.server}, DB: ${response.data.db}`
      );
    } catch (error) {
      console.log(error);
      if (
        error.response.data.response &&
        error.response.data.response.length > 0
      ) {
        setTestResponse(error.response.data.response);
      } else {
        setTestResponse("תקלה בהתחברות לשרת");
      }
    }
    setIsTestModalVisible(true);
  };

  const onInputChanged = (event) => {
    setUser({ ...user, [event.target.name]: event.target.value });
  };

  const onCheckboxChanged = (event) => {
    console.log(event.target.value);
    let updatedRoles;
    if (!user.roles.includes(event.target.name)) {
      // checked:
      updatedRoles = [...user.roles];
      updatedRoles.push(event.target.name);
    } else {
      // unchecked
      updatedRoles = user.roles.filter((role) => role !== event.target.name);
    }
    setUser({ ...user, roles: updatedRoles });
  };

  const addUser = async (event) => {
    event.preventDefault();
    if (!handleFormValidation()) {
      return;
    }
    if (editUserId) {
      try {
        const response = await axios.put(
          `/api/users/${editUserId}`,
          {
            name: user.name,
            username: user.username,
            userId: user.userId,
            roles: user.roles,
          },
          {
            headers: { Authorization: localStorage.getItem("token") },
          }
        );
        setIsAddUserModalVisible(false);
        getFarm();
      } catch (error) {
        setErrors([error.response.data.error]);
      }
    } else {
      // create new user:
      try {
        const response = await axios.post(
          "/api/users",
          { ...user, farmId: id },
          {
            headers: { Authorization: localStorage.getItem("token") },
          }
        );
        setIsAddUserModalVisible(false);
        const currentUsers = farm.users;
        currentUsers.push(response.data);
        setFarm({ ...farm, users: currentUsers });
      } catch (error) {
        setErrors([error.response.data.error]);
      }
    }
  };

  const clearForm = () => {
    setUser({
      name: "",
      username: "",
      password: "",
      userId: "",
      roles: ["user"],
    });
  };

  const handleFormValidation = () => {
    const currentErrors = [];
    if (user.roles.length < 1) {
      currentErrors.push("משתמש צריך לפחות תפקיד אחד");
    }
    if (user.name.length < 2 || user.name.length > 50) {
      currentErrors.push("שם חייב להיות בין 2-50 תווים");
    }
    if (user.username.length < 4 || user.username.length > 50) {
      currentErrors.push("שם משתמש חייב להיות בין 4-50 תווים");
    }
    if (user.userId.length < 1 || user.userId.length > 10) {
      currentErrors.push("מספר עובד חייב להיות בין 1-1,000,000 ");
    }
    if (!editUserId) {
      if (user.password.length < 4 || user.password.length > 50) {
        currentErrors.push("סיסמה חייבת להיות בין 4-50 תווים");
      }
    }

    setErrors(currentErrors);
    return currentErrors.length === 0;
    // return (
    //   user.roles.length >= 1 &&
    //   user.name.length > 2 &&
    //   user.username.length > 3 &&
    //   user.userId.length > 1 &&
    //   user.password.length > 4
    // );
  };

  const onEditFarmClicked = () => {
    setDisplayFarmEditor(true);
  };

  return (
    <div id="farm">
      <Title
        text={farm ? farm.name : ""}
        edit={true}
        onAddButtonClick={onEditFarmClicked}
        displayBackButton={true}
      />
      {isLoading && <img id="loading" src={loadingImage} alt="" />}
      {error && <h1>{error}</h1>}
      {!error && !isLoading && farm && (
        <div id="details">
          <table>
            <tbody>
              <tr>
                <td>כתובת:</td>
                <td>{farm.address}</td>
                {/* <td>
                  <button>עדכון</button>
                </td> */}
                <td>
                  <button onClick={testConnection}>בדיקת חיבור</button>
                </td>
              </tr>
              <tr>
                <td>קוד:</td>
                <td>{farm.code}</td>
                {/* <td>
                  <button>עדכון</button>
                </td> */}
              </tr>
            </tbody>
          </table>
          <Title text="עובדים" onAddButtonClick={onAddBtnClicked} />
          <table border="1">
            <thead>
              <tr>
                <th>שם</th>
                <th>שם משתמש</th>
                <th>מספר עובד</th>
                <th>תפקידים</th>
                <th>סטטוס</th>
                <th>עדכון</th>
              </tr>
            </thead>
            <tbody>
              {farm.users.map((user) => {
                return (
                  <tr key={user._id}>
                    <td>{user.name}</td>
                    <td>{user.username}</td>
                    <td>{user.userId}</td>
                    <td>
                      {user.roles.map((role) => (
                        <span key={role} className="role">
                          {role}
                        </span>
                      ))}
                    </td>
                    <td>{user.active ? "פעיל" : "לא פעיל"}</td>
                    <td>
                      <img
                        onClick={() => {
                          setEditUserId(user._id);
                          setUser({
                            name: user.name,
                            username: user.username,
                            userId: user.userId,
                            roles: user.roles,
                          });
                          setIsAddUserModalVisible(true);
                        }}
                        src={editIcon}
                        alt=""
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      <Modal
        visible={isAddUserModalVisible}
        footer={null}
        onCancel={() => {
          setIsAddUserModalVisible(false);
        }}
      >
        <h1>הוספת משתמש</h1>
        <form id="addUser" onSubmit={addUser}>
          <div className="input">
            <label htmlFor="name">שם</label>
            <input
              type="text"
              id="name"
              name="name"
              value={user.name}
              onChange={onInputChanged}
            />
          </div>
          <div className="input">
            <label htmlFor="userId">מספר עובד</label>
            <input
              type="number"
              id="userId"
              name="userId"
              value={user.userId}
              onChange={onInputChanged}
            />
          </div>
          <div className="input">
            <label htmlFor="username">שם משתמש</label>
            <input
              type="text"
              value={user.username}
              id="username"
              name="username"
              onChange={onInputChanged}
            />
          </div>
          {!editUserId && (
            <div className="input">
              <label htmlFor="password">סיסמה</label>
              <input
                type="password"
                id="password"
                name="password"
                onChange={onInputChanged}
              />
            </div>
          )}
          <div id="roles">
            <div>
              <input
                name="manager"
                onChange={onCheckboxChanged}
                type="checkbox"
                checked={user.roles.includes("manager") ? "checked" : ""}
              />{" "}
              מנהל
            </div>
            <div>
              <input
                name="user"
                onChange={onCheckboxChanged}
                type="checkbox"
                checked={user.roles.includes("user") ? "checked" : ""}
              />{" "}
              עובד
            </div>
          </div>
          <input type="submit" value="שמירת משתמש" />
          {errors && errors.length > 0 && (
            <ul>
              {errors.map((formError) => (
                <li key={formError} style={{ color: "red" }}>
                  {formError}
                </li>
              ))}
            </ul>
          )}
        </form>
      </Modal>
      <Modal
        visible={isTestModalVisible}
        footer={null}
        onCancel={() => {
          setIsTestModalVisible(false);
        }}
      >
        <h1>תוצאת בדיקת זמינות שרת חווה</h1>
        <h3>{testResponse}</h3>
      </Modal>
      {displayFarmEditor && (
        <FarmEditor
          farmId={id}
          visible={displayFarmEditor}
          onCancel={() => {
            setDisplayFarmEditor(false);
          }}
          onSuccess={() => {
            setDisplayFarmEditor(false);
            getFarm();
          }}
        />
      )}
    </div>
  );
};

export default Farm;
